import COMMON_TYPES from "../../types"
import COMMON_FRAGMENTS from "../../fragments/common"

const MENU_FRAGMENT_FUNCTION = (TYPES) => {
	return `
        id
        title
        mobileBottomBarText
        contactButtonText
        contactButtonLink {
            ... on ${TYPES.PAGES.SINGLE_PAGE} {
                slug
            }
        }
        contactHeader
        socialsHeader
        menuItems {
            id
            title
            disableMenuItem
            link {
                ... on ${TYPES.PAGES.ALL_PROJECTS_PAGE} {
                    slug
                    title
                    menuContext {
                        previewText
                        secondText
                        icon
                        disableCarouselOnHover
                        previewItems {
                            __typename
                            ... on ${TYPES.PAGES.SINGLE_PAGE} {
                                slug
                                menuPreviewImage {
                                    ${COMMON_FRAGMENTS.IMAGE_FRAGMENT}
                                }
                            }
                            ... on ${TYPES.PAGES.SINGLE_PROJECT} {
                                slug
                                menuPreviewImage {
                                    ${COMMON_FRAGMENTS.IMAGE_FRAGMENT}
                                }
                            }										
                            ... on ${TYPES.PAGES.SINGLE_HOW_WE_WORK_PAGE_NEW} {
                                slug
                                menuPreviewImage {
                                    ${COMMON_FRAGMENTS.IMAGE_FRAGMENT}
                                }
                            }
                            ... on ${COMMON_TYPES.PAGES.SERVICE_PAGE_RECORD} {
                                slug
                                menuPreviewImage {
                                    ${COMMON_FRAGMENTS.IMAGE_FRAGMENT}
                                }
                            }
                            ... on ${COMMON_TYPES.PAGES.COMPETENCES_PAGE_RECORD} {
                                slug
                                menuPreviewImage {
                                    ${COMMON_FRAGMENTS.IMAGE_FRAGMENT}
                                }
                            }
                        }
                    }
                }
                ... on ${TYPES.PAGES.SINGLE_PAGE} {
                    slug
                    menuContext {
                        previewText
                        secondText
                        icon
                        disableCarouselOnHover
                        previewItems {
                            __typename
                            ... on ${TYPES.PAGES.SINGLE_PAGE} {
                                slug
                                menuPreviewImage {
                                   ${COMMON_FRAGMENTS.IMAGE_FRAGMENT}
                                }
                            }
                            ... on ${COMMON_TYPES.PAGES.SERVICE_PAGE_RECORD} {
                                slug
                                menuPreviewImage {
                                    ${COMMON_FRAGMENTS.IMAGE_FRAGMENT}
                                }
                            }
                            ... on ${COMMON_TYPES.PAGES.COMPETENCES_PAGE_RECORD} {
                                slug
                                menuPreviewImage {
                                    ${COMMON_FRAGMENTS.IMAGE_FRAGMENT}
                                }
                            }
                            ... on ${TYPES.PAGES.SINGLE_PROJECT} {
                                slug
                                menuPreviewImage {
                                    ${COMMON_FRAGMENTS.IMAGE_FRAGMENT}
                                }
                            }								
                            ... on ${TYPES.PAGES.SINGLE_HOW_WE_WORK_PAGE_NEW} {
                                slug
                                menuPreviewImage {
                                    ${COMMON_FRAGMENTS.IMAGE_FRAGMENT}
                                }
                            }
                        }
                    }
                }
                ... on GroupSinglePageRecord {
                    id
                    slug
                    menuContext {
                        __typename
                        id
                        disableCarouselOnHover
                        previewText
                        previewItems {
                            ... on CommonBlogPageRecord {
                                __typename
                                id
                                blogPageName
                                slug
                                pleoCategory
                                thumbnailImage {
                                    ${COMMON_FRAGMENTS.IMAGE_FRAGMENT}										
                                }
                            }
                        }
                    }
                }
            }
        }
    `
}

const GLOBALS_FRAGMENT_FUNCTION = (TYPES) => {
	return `
        id
        title
        pleoType
        address
        email
        phone
        title
        socials {
            id
            title
            link
        }
        modalHeader
        modalDescription
        buttonTextClose
        buttonTextOpen
        readArticleButtonText
        toTopButton
        cookiesButton
        projectElevatorText
        policyButton {
          text
          link{
            ... on ${TYPES.PAGES.SINGLE_PAGE}{
              slug
            }
          }
        }
    `
}

const COOKIES_FRAGMENT = `
    title
    header
    description
    backButton
    configButton
    acceptAllButton
    acceptSelectedButton
    generalButton
    generalDescription
    image {
        ${COMMON_FRAGMENTS.IMAGE_FRAGMENT}
    }
    addCookies {
        cookieName
        cookieType
        cookieDescription
    }
`

const FOOTER_FRAGMENT_FUNCTION = (TYPES) => {
	return `
        id
        tagInfo: info
        tagLink: link{
            text
            url
        }
        video{
            title
            assetId
            thumbnailUrl
            muxPlaybackId: playbackId
            streamingUrl
            width
            height
            duration
        }
        links {
            ... on ${TYPES.PAGES.SINGLE_PAGE} {
                slug
                name
            }
            ... on ${TYPES.PAGES.ALL_PROJECTS_PAGE} {
                slug
                name
            }
        }
        logos {
            id
            logoLink
            logo {
                ${COMMON_FRAGMENTS.IMAGE_FRAGMENT}
            }
        }
    `
}

export default {
	MENU_FRAGMENT_FUNCTION,
	GLOBALS_FRAGMENT_FUNCTION,
	FOOTER_FRAGMENT_FUNCTION,
	COOKIES_FRAGMENT,
}
